import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackFormSubmitParameters extends TrackEventBaseParameters<null, "form_name"> {}

const trackFormSubmit = (parameters: TrackFormSubmitParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "submit_form", ...parameters }, options);
};

export default trackFormSubmit;
